"use strict";
var moment = require("moment-timezone");
moment.locale("pt-br");

module.exports.capitalizeFirstLetter = function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

module.exports.escapeRegexSpecificCharacters = function escapeRegexSpecificCharacters(text) {
  //Escapes regex specific character to search
  if(typeof text === "string") {
    return text.replace(/[\.\\\[\]\^\$\?\(\)\:\+\*\{\}\|\-]/g, "\\$&");
  }
};

module.exports.dateToUserFormat = function dateToUserFormat(date) {
  if (date && !isNaN(Date.parse(date))) {
    var dateObj = moment(date);

    return dateObj.format("DD/MM/YYYY HH:mm");
  } else {
    return undefined;
  }
};

/**
* Converts a date in a given timezone, to another given timezone. The date is
* expected to have no timezone offset.
*
* Usage example:
*   textFormatter.dateToTimezone("2010-01-31 12:00:00", "America/Sao_Paulo, "UTC");
* @param {string} date - The date to be converted in the format
* "2010-01-31 12:00:00"
* @param {string} dateTzId - The current timezone.
* @param {string} tzId - The timezone to convert to.
*/
module.exports.dateToTimezone = function dateToTimezone(date, dateTzId, tzId) {
  return moment.tz(date, dateTzId).tz(tzId);
};

module.exports.trim = function trim(text) {
  if(typeof text === "string") {
    return text.trim();
  } else {
    return text;
  }
};

module.exports.isInt = function isInt(value) {
  var intPattern = new RegExp("^[0-9]*$");
  return intPattern.test(value);
};

module.exports.pluralize = function pluralize(singular, plural, count, force = false) {
  return (force || Math.abs(count) > 1) ? plural : singular;
};

module.exports.formatValueWithSign = function(value) {
  if (String(value).charAt(0) === "-") {
    return value;
  }

  return "+" + value;
};

module.exports.formatValuePercentage = function(value) {
  return (value + "%").replace('.', ',');
};



// WEBPACK FOOTER //
// ./app/util/formatter/text.js